<script lang="ts">
	import type { TrafficScheme } from './types';
	import Badge from '$lib/components/atoms/badge/Badge.svelte';
	import SkeletonBlock from '$lib/components/atoms/skeleton/SkeletonBlock.svelte';
	import { trafficEvent } from '$lib/i18n/computed/trafficEvent';
	import { mapTrafficSchemeToColor, mapTrafficSchemeToIcon } from './constants';

	export let isLoading = false;
	export let scheme: TrafficScheme = 'carIncident';
	export let info = '';
</script>

<div class="rd-2 p-4 flex flex-col gap-2 shadow-smooth-bottom-1 bg-neutral-weakest w-full">
	{#if isLoading}
		<SkeletonBlock width="102px" height="28px" borderRadius="4px" />
		<div class="flex flex-col gap-1">
			<SkeletonBlock height="10px" width="296px" />
			<SkeletonBlock height="10px" width="217px" />
		</div>
	{:else}
		<Badge
			color={mapTrafficSchemeToColor[scheme]}
			icon={mapTrafficSchemeToIcon[scheme]}
			text={trafficEvent(scheme)}
			isSquare
		/>
		<div class="text-sm">{info}</div>
	{/if}
</div>
